import React from 'react';
import './AuthHeader.css';
import logo from '../../assets/images/logo.png'
import { useNavigate } from "react-router-dom";

/**
 * AuthHeader Component
 * 
 * Header navigation for authentication pages
 * Contains logo, tagline, navigation links, and action buttons
 * 
 * @component
 */
const AuthHeader = () => {
  const navigate = useNavigate();
  // Navigation links data
  const navLinks = [
    { label: 'about us', href: '#about' },
    // { label: 'faq', href: '#faq' },
    { label: 'pricing', href: '#pricing' },
    // { label: 'demo', href: '#demo' },
    // { label: 'blog', href: '#blog' },
    { label: 'print material', href: '#print-material' }
  ];

  // Dummy handler for navigation clicks (no actual routing)
  const handleNavClick = (e, href) => {
    e.preventDefault();
    console.log('Navigate to:', href);
  };

  // Dummy handler for login button
  const handleLogin = () => {
    console.log('Login clicked');
    navigate('/login');
  };

  return (
    <header className="auth-header">
      {/* Left section - Logo and tagline */}
      <div className="auth-header__left">
        <div className="auth-header__logo">
          <div className="auth-header__logo-icon">
            <img src={logo} />
            <div className="auth-header__tagline">
              the out & about chat app
            </div>
          </div>
        </div>
      </div>

      {/* Center section - Navigation links */}
      {/* <nav className="auth-header__nav">
        {navLinks.map((link) => (
          <a
            key={link.label}
            href={link.href}
            className="auth-header__nav-link"
            onClick={(e) => handleNavClick(e, link.href)}
          >
            {link.label}
          </a>
        ))}
      </nav> */}

      {/* Right section - Action buttons */}
      <div className="auth-header__actions">
        <nav className="auth-header__nav">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="auth-header__nav-link"
              onClick={(e) => handleNavClick(e, link.href)}
            >
              {link.label}
            </a>
          ))}
        </nav>
        <button
          className="auth-header__btn auth-header__btn--login"
          onClick={handleLogin}
        >
          login
        </button>
      </div>
    </header>
  );
};

export default AuthHeader;



